<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21.405"
    height="21.183"
    viewBox="0 0 21.405 21.183"
  >
    <g transform="translate(-1102.166 -579.659)">
      <path
        d="M1119.563,600.021l-.979-.208a32.948,32.948,0,0,0,.72-7.7,5.774,5.774,0,0,0-4.188-5.975,2.076,2.076,0,0,1-.281-.048c-.855-.187-3.458-.762-5.77,2.679-2.742,4.083-1.637,9.374-1.627,9.426l-.976.213c-.051-.232-1.211-5.753,1.773-10.2,1.782-2.654,4.066-3.7,6.8-3.1l.028-.022.242.064a6.76,6.76,0,0,1,5,6.983A33.783,33.783,0,0,1,1119.563,600.021Z"
      />
      <rect
        width="0.999"
        height="5.851"
        transform="matrix(0.483, -0.875, 0.875, 0.483, 1110.86, 595.6)"
      />
      <path
        d="M1111.117,598.537l-.48-.877,5.347-2.937.48.877Z"
      />
      <rect
        width="0.999"
        height="5.134"
        transform="translate(1111.215 598.238) rotate(-59.567)"
      />
      <rect
        width="5.572"
        height="1"
        transform="translate(1110.635 599.975) rotate(-29.87)"
      />
      <rect
        width="19"
        height="1"
        transform="translate(1103.657 581.541)"
      />
      <path
        d="M1104.492,584.549l-2.326-2.791,2.379-2.1.662.75-1.65,1.456,1.7,2.043Z"
      />
      <path
        d="M1121.245,584.549l-.768-.641,1.7-2.043-1.65-1.456.662-.75,2.379,2.1Z"
      />
    </g>
  </svg>
</template>
